'use client';

import SeasonalPromoDialog, {
  type SeasonalPromoDialogProps,
} from '@/components/global/seasonal/SeasonalPromoDialog';

/**
 * Promo popup, "Black Month 2026" design — Figma 12770:42014 (desktop) and
 * 12770:42070 (mobile), with the affiliate code box on partner pages. The
 * layout lives in SeasonalPromoDialog.
 */
export default function PromoBannerDialogBlackMonth(
  props: Omit<SeasonalPromoDialogProps, 'theme'>,
) {
  return <SeasonalPromoDialog {...props} theme="blackMonth" />;
}
